export default __webpack_public_path__ + "static/banner-a4310712d3f7590a8b4e1a08a1cf00a5.png";